interface StateType {
    mainBackground: string;
    bottomBackground: string;
    awardBackground: string;
    rankBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        awardBackground: '',
        rankBackground: '',
        mainBackground: '',
        bottomBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            // console.log('key, value', key, value);
            state[key] = value;
        }
    },

    namespaced: true
};
